import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { JhiLanguageService, EventManager} from 'ng-jhipster';
import { Principal } from '../../shared';
import { School, SchoolService} from '../../entities/school';

@Component({
    selector: 'jhi-footer',
    templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit, OnDestroy {

    currentSchool: School;
    currentUserSubscriber: Subscription;
    colorSubscriber: Subscription;
    logoutSubscriber: Subscription;
    color: string;

    constructor(
        private languageService: JhiLanguageService,
        private eventManager: EventManager,
        private principal: Principal,
        private schoolService: SchoolService
    ) {
    }

    ngOnInit() {
        this.loadAccountConfig();

        this.currentUserSubscriber = this.eventManager
                                        .subscribe('authenticationSuccess',
                                        (res) => {
                                            this.principal.identity().then((account) => {
                                                this.schoolService.findCurrent()
                                                .subscribe(school => {
                                                    this.loadAccountConfig();
                                                });
                                            });
                                        });
        this.colorSubscriber = this.eventManager
                                .subscribe('footerColorModification',
                                    (res) =>  this.color = '#' + res.content );
    }

    ngOnDestroy() {
        this.currentUserSubscriber.unsubscribe();
        this.colorSubscriber.unsubscribe();
        this.logoutSubscriber.unsubscribe();
    }

    private loadAccountConfig() {
        this.color =  this.schoolService.getColor('footer');
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/footer/footer.component.ts